// extracted by mini-css-extract-plugin
export default {"main":"layout_main__0C+vY","flex":"layout_flex__9dZwC","content":"layout_content__Iy6hQ","fullContent":"layout_fullContent__nF0Qm","center":"layout_center__DNGLH"};